import {Injectable} from '@angular/core';
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {DataService} from "../../../../services/external-api/data.service";
import {emptyServiceResponse, IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {emptyUserNotification, IUserNotification} from "./api-user-notifications.interfaces";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class ApiUserNotificationsService {

  constructor(
    private dataService: DataService,
    private configurationManager: ConfigurationManager) {

  }

  getUserNotifications(showMessages = false): Observable<Array<IUserNotification>> {
    const url = showMessages?`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications?message=yes`:`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications`;
    return this.dataService.getReportData(url, {}).pipe(
      map(
        result => {
          return result.report.map(t => ({
            ...emptyUserNotification,
            id: t.user_notification_id?t.user_notification_id.toString():'0',
            date: moment(t.date_create,'YYYYMMDD hh:mm:ss').toDate(),
            subject: t.subject?t.subject:'',
            text: t.message?t.message:'',
            priority: t.priority?t.message:'normal'
          }));
        }
      )
    );

    if (this.configurationManager.realm === 'auchan_ua' && this.configurationManager.configuration.auth.module === 'ldap') {
      /*
      const notifications: Array<IUserNotification> = [{
        ...emptyUserNotification,
        date: moment('20200930 9:00', 'YYYYMMDD HH:mm').toDate(),
        subject: '',
        text: 'Шановний користувач!<br> Якщо ви підписали з ТОВ "Ашан Україна Гіпермаркет" п.3.1.4. Договору про торговельне співробітництво (надання послуг), вам доступний новий звіт по програмі лояльності  Loyalty reports у ваших Підписках.',
        priority: "urgent"
      }];
      return of(notifications);
      */
      return of([]);
    } else if (this.configurationManager.realm === 'auchan_ro' && this.configurationManager.configuration.auth.module === 'ldap') {
      /*
      const notifications: Array<IUserNotification> = [{
        ...emptyUserNotification,
        date: moment('20210423 10:00', 'YYYYMMDD HH:mm').toDate(),
        subject: '',
        text: 'Stimati parteneri,<br>Va anuntam ca in data de 27.04.2021 aplicatia EXTRANET nu va fi disponibila din cauza unor lucrari de mentenanta.<br>Ne cerem scuze pentru neplacerile cauzate!',
        priority: "urgent"
      }];
      return of(notifications);
      */
      return of([]);
    } else {
      if (this.configurationManager.realm === 'portal') {

        const notifications: Array<IUserNotification> = [{
          ...emptyUserNotification,
          date: moment('20200928', 'YYYYMMDD').toDate(),
          subject: '',
          text: 'Тестовое сообщение для пользователей<br> В несколько строк.<br> Выводится только на девелоперской среде',
          priority: "urgent"
        }];
        return of(notifications);
      } else return of([]);
    }
  }

  getUserNotification(id: string):Observable<IUserNotification> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications/${id}`, {}).pipe(
      map(
        result => {
          return result.report.length>0?{
            ...emptyUserNotification,
            id: result.report[0].user_notification_id?result.report[0].user_notification_id.toString():'0',
            date: moment(result.report[0].date_create,'YYYYMMDD hh:mm:ss').toDate(),
            subject: result.report[0].subject?result.report[0].subject:'',
            text: result.report[0].message?result.report[0].message:'',
            priority: result.report[0].priority?result.report[0].message:'normal'
          }:{...emptyUserNotification}

        }
      )
    );

  }
  createUserNotification(notification: IUserNotification):Observable<IServiceResponse>{
    const param = {
      "priority": notification.priority?notification.priority:'normal',
      "subject": notification.subject?notification.subject:'',
      "message": notification.text?notification.text:'',
      "profile": null
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications`,{},param);
  }
  updateUserNotification(notification: IUserNotification): Observable<IServiceResponse> {
    const param = {
      "priority": notification.priority?notification.priority:'normal',
      "subject": notification.subject?notification.subject:'',
      "message": notification.text?notification.text:'',
      "profile": null
    };
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications/${notification.id}`,{},param);

  }
  deleteUserNotification(id: string): Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiPlatformUrl')}/users/notifications/${id}`,{});
  }

}
